import Switch from 'react-switch';

import * as S from './SwitchBtn.styles';

interface SwitchBtnProps {
  label: string;
  onChange: (value: boolean) => void;
  isOn: boolean;
}

export const SwitchBtn: React.FC<SwitchBtnProps> = ({ label, onChange, isOn }) => (
  <S.Wrapper>
    {label}
    <Switch
      uncheckedIcon={false}
      checkedIcon={false}
      height={16}
      width={32}
      onChange={onChange}
      checked={isOn}
    />
  </S.Wrapper>
);
